<template>
	<div class="mini-programe-body">
		<div class="fx-header">
			<p>小程序</p>
		</div>
		<div class="mini-programe-container">
			<el-collapse v-model="activeNames">
				<el-collapse-item title="小程序注册" class="accept-order" name="1">
					<div style="width:50%;">
						<div class="long-span-box">是否应用小程序注册通道：</div>
						<el-select :disabled="!AuthorityList['06_0003_0002_00']" size="mini" v-model="registFlag" class="select-box" @change="registSetting()">
							<el-option label="不应用" value="0"></el-option>
							<el-option label="应用" value="1"></el-option>
						</el-select>
					</div>
					<div style="width:50%;">
						<div class="long-span-box">注册用户默认启用状态：</div>
						<el-select :disabled="!AuthorityList['06_0003_0002_00']" size="mini" v-model="defaultcustomerdisabledflag" class="select-box" @change="defaultcustomerdisabledflagChange()">
							<el-option label="启用" :value="true"></el-option>
							<el-option label="禁用" :value="false"></el-option>
						</el-select>
					</div>
					<div style="width:50%;">
						<div class="long-span-box">注册用户默认店铺：</div>
						<el-select :disabled="!AuthorityList['06_0003_0002_00']" size="mini" v-model="registShopListFlag" class="select-box" @change="registShopListChange()">
							<el-option label="全部" :value="false"></el-option>
							<el-option label="自定义" :value="true"></el-option>
						</el-select>
						<el-button v-if="registShopListFlag" size="small" type="primary" class="btn fx-btn" style="margin-left: 10px" @click="bindingModal = true">{{ registShopList.length === 0 ? '选择店铺' : '已选' + registShopList.length + '个店铺' }}</el-button>
					</div>
				</el-collapse-item>
				<el-collapse-item title="采购页显示" class="accept-order" name="2">
					<div>
						<div class="long-span-box">是否显示商品库存：</div>
						<el-select :disabled="!AuthorityList['06_0003_0002_00']" size="mini" v-model="showInventoryFlag" class="select-box" @change="showInventoryFlagChange()">
							<el-option label="是" :value="true"></el-option>
							<el-option label="否" :value="false"></el-option>
						</el-select>
					</div>
					<div>
						<div class="long-span-box">采购页默认展示模式：</div>
						<el-select :disabled="!AuthorityList['06_0003_0002_00']" size="mini" v-model="defaultImgShowType" class="select-box" @change="defaultImgShowTypeChange()">
							<el-option label="小图模式" :value="0"></el-option>
							<el-option label="大图模式" :value="1"></el-option>
							<el-option label="无图模式" :value="2"></el-option>
						</el-select>
					</div>
					<div>
						<div class="long-span-box">是否显示包装清单：</div>
						<el-select :disabled="!AuthorityList['06_0003_0002_00']" size="mini" v-model="showpacklist" class="select-box" @change="showpacklistChange()">
							<el-option label="是" :value="1"></el-option>
							<el-option label="否" :value="0"></el-option>
						</el-select>
					</div>
					<div>
						<div class="long-span-box">采购页商品价格颜色：</div>
						<el-select :disabled="!AuthorityList['06_0003_0002_00']" size="mini" v-model="priceColor" class="select-box" @change="priceColorChange()">
							<el-option label="黑色" value="#333333">
								<div class="color-box">黑色#333333<div class="color-box-black"></div></div>
							</el-option>
							<el-option label="红色" value="#E20300">
								<div class="color-box">红色#E20300<div class="color-box-red"></div></div>
							</el-option>
						</el-select>
					</div>
				</el-collapse-item>
				<el-collapse-item title="确认订单" class="accept-order" name="3">
					<div>
						<div class="long-span-box">是否需要上传附件：</div>
						<el-select :disabled="!AuthorityList['06_0003_0002_00']" size="mini" v-model="isUploadFilesFlag" class="select-box" @change="isUploadFilesFlagChange()">
							<el-option label="需要上传附件" :value="1"></el-option>
							<el-option label="不需要上传附件" :value="0"></el-option>
						</el-select>
					</div>
					<div>
						<div class="long-span-box">是否进行购买提示：</div>
						<el-input
							class="info-textarea"
							type="textarea"
							placeholder="请输入提示文字"
							maxlength="20"
							resize="none"
							rows="2"
							size="mini"
							show-word-limit
							v-model="warningInfo"
							:disabled="!AuthorityList['06_0003_0002_00']"
							@blur="saveWarningInfo">
						</el-input>
						<div style="display:inline-block;margin-left:20px;">弹窗提示
							<el-switch
								v-model="warningflag"
								:disabled="!warningInfo"
								@change="setWarningFlag"
								:active-color="$fxPrimaryColor"
								inactive-color="#dcdfe6">
							</el-switch>
						</div>
					</div>
					<div style="margin-top:10px;">
						<div class="long-span-box">是否显示期望到货时间：</div>
						<el-select :disabled="!AuthorityList['06_0003_0002_00']" size="mini" v-model="showWantArrivalDate" class="select-box" @change="showWantArrivalDateChange()">
							<el-option label="是" :value="1"></el-option>
							<el-option label="否" :value="0"></el-option>
						</el-select>
					</div>
					<div style="margin-top:10px;">
						<div class="long-span-box" style="width:280px;">组合品是否受组合品内关联商品私密状态限制：</div>
						<el-select :disabled="!AuthorityList['06_0003_0002_00']" size="mini" v-model="packageHiddenFlag" class="select-box" @change="packageHiddenFlagChange">
							<el-option label="是" :value="1"></el-option>
							<el-option label="否" :value="0"></el-option>
						</el-select>
					</div>
				</el-collapse-item>
				<el-collapse-item title="购物车限制" class="accept-order" name="4">
					<div>
						<div class="long-span-box">分类结算限制：</div>
						<el-select :disabled="!AuthorityList['06_0003_0002_00']" size="mini" v-model="mutexpurchase" class="select-box" @change="mutexpurchaseChange()">
							<el-option label="开启" :value="true"></el-option>
							<el-option label="关闭" :value="false"></el-option>
						</el-select>
						<span style="margin-left:10px">注：打开允许后需要配置分类限制关系，配置后商品所属分类互斥，则需要在购物车分别独立提单！</span>
					</div>
					<div v-show="mutexpurchase" v-for="(item, index) in cateList" :key="index" class='row-box'>
						<el-cascader
							size="mini"
							style="width:300px"
							collapse-tags
							@change="reloadCate(index,'1')"
							v-model="item.item_1.value"
							:options="item.item_1.options"
							:props="{ multiple: true, label: 'name', value: 'id',children: 'sc'}"
							>
						</el-cascader>
						<span style="margin: 0 10px">与</span>
						<el-cascader
							size="mini"
							collapse-tags
							style="width:300px"
							@change="reloadCate(index,'2')"
							v-model="item.item_2.value"
							:options="item.item_2.options"
							:props="{ multiple: true, label: 'name', value: 'id',children: 'sc'}"
							>
						</el-cascader>
						<div style="margin-left:20px">
							<el-button :disabled="cateList.length === 10 || cateList.length !== index + 1" size="mini" type="text" @click="addClick">添加一行</el-button>
							<el-button :disabled="cateList.length === 1" size="mini" type="text" @click="delClick(index)">删除</el-button>
						</div>
					</div>
					<div v-show="mutexpurchase" style="width:100%;height:40px;text-align:center;line-height:40px">
						<el-button size="mini" plain type="primary" @click="saveClick">保存</el-button>
					</div>
				</el-collapse-item>
				<el-collapse-item title="个人中心" class="accept-order" name="5">
					<div style="width:50%;">
						<div class="long-span-box">预付货款充值：</div>
						<el-select :disabled="!AuthorityList['06_0003_0002_00']" size="mini" v-model="allowfillpremoneyflag" class="select-box" @change="allowfillpremoneyflagSetting()">
							<el-option label="允许" :value="1"></el-option>
							<el-option label="不允许" :value="0"></el-option>
						</el-select>
					</div>
				</el-collapse-item>
				<el-collapse-item title="常购清单" class="accept-order" name="6">
					<div style="width:50%;">
						<div class="long-span-box">是否允许替换组合品明细：</div>
						<el-select  size="mini" v-model="replaceproductpackage" class="select-box" @change="replaceproductpackageSetting">
							<el-option label="是" :value="1"></el-option>
							<el-option label="否" :value="0"></el-option>
						</el-select>
					</div>
					<div style="width:50%;">
						<div class="long-span-box">是否允许批量购买：</div>
						<el-select  size="mini" v-model="batchConfirm" class="select-box" @change="batchConfirmSetting">
							<el-option label="是" :value="1"></el-option>
							<el-option label="否" :value="0"></el-option>
						</el-select>
					</div>
				</el-collapse-item>
				<el-collapse-item title="其他" class="accept-order" name="7">
					<div class="radio-wrap">
						<div class="long-span-box" style="width:280px;">小程序订单、退单、报表允许查询时间范围：</div>
						<el-radio-group v-model="showOrderListDateType" @change="showOrderListDateTypeChange" style="display:inline-block;margin-right:20px">
							<el-radio :label="0">系统默认</el-radio>
							<el-radio :label="1">自定义</el-radio>
						</el-radio-group>
						<div v-show="showOrderListDateType === 1">
							近<el-input size="mini" @input="monthInput" @blur="monthBlur" style="margin:0 10px 20px;width:100px" v-model="showOrderListDateCount" class="select-box"></el-input>月
						</div>
					</div>
					<div style="width:50%;">
						<div class="long-span-box">是否小程序被腾讯公众平台风控：</div>
						<el-select size="mini" v-model="weChatShippingFlag" :disabled="weChatShippingFlag === 1" class="select-box" @change="weChatShippingFlagSetting">
							<el-option label="是" :value="1"></el-option>
							<el-option label="否" :value="0"></el-option>
						</el-select>
						<el-tooltip effect="dark" placement="top" popper-class="tip-class">
							<div slot="content">
								1、该参数必须买家小程序被腾讯公众平台风控时再开启，未被风控不要开启，否则资金将被腾讯冻结，无法实时到账。（风控指的是使用微信支付资金无法实时到账，被腾讯公众平台冻结，需要在腾讯后台发货后自动收货资金才会解冻。）<br/>
								2、规则：开启参数后，极速订每笔微信支付流水支付后会给腾讯公众平台传发货状态，腾讯平台收到后，在腾讯平台发货状态会变成已发货，腾讯平台规定已发货后T+2自动收货，资金会解冻到账。<br/>
								3、上述规则说明只针对于微信支付，参数开启后产生的流水生效，开启前产生的流水不生效。<br/>
								4、有任何其他疑问请咨询腾讯公众平台客服，腾讯公众平台说明地址：<a style="color:var(--fx-primary-color);text-decoration:underline;" href="https://developers.weixin.qq.com/miniprogram/product/jiaoyilei/yunyingguifan.html#_1-5-%E8%B5%84%E9%87%91%E7%BB%93%E7%AE%97" target="_blank">https://developers.weixin.qq.com/miniprogram/product/jiaoyilei/yunyingguifan.html#_1-5-%E8%B5%84%E9%87%91%E7%BB%93%E7%AE%97</a>
							</div>
							<img src="~/images/icon/tooltip-icon.png" class="tip-icon">
						</el-tooltip>
					</div>
				</el-collapse-item>
			</el-collapse>
		</div>
		<el-dialog title="选择店铺" class="dialog-title" :visible.sync="bindingModal" width='1200px' :before-close="cancelDialog" :close-on-click-modal="false">
			<binding :selectedShopList='registShopList' @cancel='cancelDialog' :isShow='bindingModal' @saveClick="saveBind"></binding>
		</el-dialog>
	</div>
</template>

<script>
import binding from '@/components/miniProgram/binding.vue'
export default {
	name: 'miniPrograme',
	components: {
		binding
	},
	data () {
		return {
			bindingModal: false,
			registShopListFlag: null,
			registShopList: [],
			replaceproductpackage: 0,
			allowfillpremoneyflag: 0,
			options: [],
			cateList: [],
			defaultcustomerdisabledflag: null,
			activeNames: ['1', '2', '3', '4', '5', '6', '7'],
			registFlag: '',
			showInventoryFlag: null,
			defaultImgShowType: null,
			isUploadFilesFlag: 0,
			isShowBuyTipsFlag: 0,
			warningInfo: '',
			AuthorityList: {
				'06_0003_0001_00': false,
				'06_0003_0002_00': false
			},
			ruleForm: {},
			fxDataVerification: this.$fxUtils.fxDataVerification(),
			bigcategoryview: false,
			mutexpurchase: false,
			showWantArrivalDate: false,
			showpacklist: 0,
			batchConfirm: 0,
			warningflag: false,
			packageHiddenFlag: 1,
			showOrderListDateType: 0,
			showOrderListDateCount: '',
			priceColor: '#333',
			weChatShippingFlag: false
		}
	},
	created () {
		this.checkSmallCategory()
		this.getAuthority('06_0003_0000_00')
		this.getAllFlag()
	},
	methods: {
		cancelDialog () {
			this.bindingModal = false
			this.getAllFlag()
		},
		saveBind (data) {
			this.registShopList = data
			this.saveRegistShopList()
		},
		registShopLogger () {
			let message = this.registShopListFlag ? this.registShopList.map(item => {
				return item.name
			}).join(',') : '全部'
			return message
		},
		saveRegistShopList () {
			let data = {
				customFlag: this.registShopListFlag,
				shopList: this.registShopList
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/systemcenter/saveregistshoplist`,
				data: data
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.cancelDialog()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		registShopListChange () {
			if (!this.registShopListFlag) {
				this.saveRegistShopList()
			}
		},
		addClick () {
			let row = {
				item_1: {
					options: JSON.parse(JSON.stringify(this.options)),
					value: []
				},
				item_2: {
					options: JSON.parse(JSON.stringify(this.options)),
					value: []
				}
			}
			this.cateList.push(row)
		},
		delClick (index) {
			this.cateList.splice(index, 1)
		},
		checkCate () {
			let list = this.cateList
			let flag = false
			list.forEach(item => {
				if (item.item_1.value.length === 0 || item.item_2.value.length === 0) {
					flag = true
				}
			})
			return flag
		},
		showOrderListDateTypeChange () {
			const preState = this.showOrderListDateType === 1 ? '系统默认' : '自定义'
			const curState = this.showOrderListDateType === 0 ? '系统默认' : '自定义'
			let loggerMessage = `小程序订单、退单、报表允许查询时间范围由"${preState}"改为"${curState}"`
			const params = {
				showOrderListDateType: this.showOrderListDateType,
				message: loggerMessage
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setShowOrderListDateType`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.getAllFlag()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		monthInput () {
			this.showOrderListDateCount = this.showOrderListDateCount.replace(/[^\d]/g, '')
		},
		monthBlur () {
			if (this.showOrderListDateCount <= 0 || this.showOrderListDateCount > 36) {
				this.$message.error('请输入1~36之间的数字')
				return false
			}
			let loggerMessage = `小程序订单、退单、报表允许查询时间范围由"${this.ruleForm.showOrderListDateCount}"个月改为"${this.showOrderListDateCount}"个月`
			const params = {
				showOrderListDateCount: this.showOrderListDateCount,
				message: loggerMessage
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setShowOrderListDateCount`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.getAllFlag()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		initItem (arr) {
			let list = []
			arr.value.forEach(item => {
				console.log(item)
				let row = {}
				if (this.bigcategoryview) {
					row = {
						bigCategoryId: item[0],
						smallCategoryId: item[1]
					}
				} else {
					row = {
						bigCategoryId: item[0],
						smallCategoryId: null
					}
				}
				list.push(row)
			})
			return list
		},
		saveClick () {
			if (this.checkCate()) {
				this.$message.error('请选择商品类别')
				return false
			}
			let arr = []
			this.cateList.forEach(item => {
				let row = {
					frontMutexPurchaseCategoryDTOList: this.initItem(item.item_1),
					behindMutexPurchaseCategoryDTOList: this.initItem(item.item_2)
				}
				arr.push(row)
			})
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/saveMutexPurchase`,
				data: arr
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.getDetail()
				}
			})
		},
		getDetail () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/findMutexPurchase`
			}).then(res => {
				if (res.result) {
					console.log(res)
					this.initCate(res.data)
				}
			})
		},
		getTree () {
			let params = {
				name: ''
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/category/mutex/get`,
				data: params
			}).then(res => {
				if (res.result) {
					let list = res.data
					let arr = []
					if (!this.bigcategoryview) {
						list.forEach(item => {
							let row = {
								id: item.id,
								name: item.name
							}
							arr.push(row)
						})
						this.options = arr
					} else {
						this.options = res.data
					}
					this.getDetail()
				}
			})
		},
		// 是否开启小类
		checkSmallCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.bigcategoryview = res.bigcategoryview === 1
				this.getTree()
			})
		},
		initCate (data) {
			if (data.length === 0) {
				this.cateList = [
					{
						item_1: {
							options: JSON.parse(JSON.stringify(this.options)),
							value: []
						},
						item_2: {
							options: JSON.parse(JSON.stringify(this.options)),
							value: []
						}
					}
				]
			} else {
				let arr = []
				data.forEach(item => {
					console.log(item)
					let list1 = []
					let list2 = []
					if (this.bigcategoryview) {
						list2 = item.behindMutexPurchaseCategoryDTOList.map(a => {
							return [a.bigCategoryId, a.smallCategoryId]
						})
						list1 = item.frontMutexPurchaseCategoryDTOList.map(a => {
							return [a.bigCategoryId, a.smallCategoryId]
						})
					} else {
						list2 = item.behindMutexPurchaseCategoryDTOList.map(a => {
							return [a.bigCategoryId]
						})
						list1 = item.frontMutexPurchaseCategoryDTOList.map(a => {
							return [a.bigCategoryId]
						})
					}
					let row = {
						item_1: {
							options: JSON.parse(JSON.stringify(this.options)),
							value: list1
						},
						item_2: {
							options: JSON.parse(JSON.stringify(this.options)),
							value: list2
						}
					}
					arr.push(row)
				})
				this.cateList = arr
				for (let i = 0; i < arr.length; i++) {
					this.reloadCate(i, '1')
					this.reloadCate(i, '2')
				}
			}
		},
		reloadCate (index, flag) {
			let chooseArr = []
			if (flag === '1') {
				if (this.bigcategoryview) {
					chooseArr = this.cateList[index].item_1.value.map(item => {
						return item[1]
					})
				} else {
					chooseArr = this.cateList[index].item_1.value.map(item => {
						return item[0]
					})
				}
				this.cateList[index].item_2.options = this.checkDisable(chooseArr)
			} else {
				if (this.bigcategoryview) {
					chooseArr = this.cateList[index].item_2.value.map(item => {
						return item[1]
					})
				} else {
					chooseArr = this.cateList[index].item_2.value.map(item => {
						return item[0]
					})
				}
				this.cateList[index].item_1.options = this.checkDisable(chooseArr)
			}
		},
		checkDisable (choooseArr) {
			let list = JSON.parse(JSON.stringify(this.options))
			if (this.bigcategoryview) {
				list.forEach(item => {
					let num = 0
					item.sc.forEach(childrenItem => {
						if (choooseArr.includes(childrenItem.id)) {
							childrenItem.disabled = true
							num++
						} else {
							childrenItem.disabled = false
						}
					})
					item.disabled = (num === item.sc.length)
				})
			} else {
				list.forEach(item => {
					if (choooseArr.includes(item.id)) {
						item.disabled = true
					} else {
						item.disabled = false
					}
				})
			}
			return list
		},
		showWantArrivalDateChange () {
			let formData = new FormData()
			formData.append('showWantArrivalDate', this.showWantArrivalDate)
			this.ruleForm.showWantArrivalDate = this.showWantArrivalDate
			const logger = this.$fxLogger.createInfo('system.mini-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setShowWantArrivalDate`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.getAllFlag()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		packageHiddenFlagChange () {
			// let formData = new FormData()
			// formData.append('packageHiddenFlag', this.packageHiddenFlag)
			const preState = this.packageHiddenFlag === 0 ? '是' : '否'
			const curState = this.packageHiddenFlag === 1 ? '是' : '否'
			let loggerMessage = `组合品是否受组合品内关联商品私密状态限制由"${preState}"改为"${curState}"`
			let loggerUrl = window.location.href.split('?')[0]
			loggerUrl = loggerUrl.replace(window.location.origin, '').substring(1)
			const params = {
				packageHiddenFlag: this.packageHiddenFlag,
				message: loggerMessage,
				referer: loggerUrl
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setPackageHiddenFlag`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.getAllFlag()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		mutexpurchaseChange () {
			let formData = new FormData()
			formData.append('mutexpurchase', this.mutexpurchase)
			this.ruleForm.mutexpurchase = this.mutexpurchase
			const logger = this.$fxLogger.createInfo('system.mini-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setMutexPurchase`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.getAllFlag()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		defaultcustomerdisabledflagChange () {
			let formData = new FormData()
			formData.append('defaultcustomerdisabledflag', this.defaultcustomerdisabledflag)
			this.ruleForm.defaultcustomerdisabledflag = this.defaultcustomerdisabledflag
			const logger = this.$fxLogger.createInfo('system.mini-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setCustomerDefaultDisabledFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.getAllFlag()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		defaultImgShowTypeChange () {
			let formData = new FormData()
			formData.append('defaultImgShowType', this.defaultImgShowType)
			this.ruleForm.defaultImgShowType = this.defaultImgShowType
			const logger = this.$fxLogger.createInfo('system.mini-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setDefaultImgShowType`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.getAllFlag()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		showpacklistChange () {
			let formData = new FormData()
			formData.append('showpacklist', this.showpacklist)
			this.ruleForm.showpacklist = this.showpacklist
			const logger = this.$fxLogger.createInfo('system.mini-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setShowPackList`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.getAllFlag()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		priceColorChange () {
			const preState = this.priceColor === '#333333' ? '红色' : '黑色'
			const curState = this.priceColor === '#333333' ? '黑色' : '红色'
			let loggerMessage = `采购页商品价格颜色由"${preState}"改为"${curState}"`
			const params = {
				priceColor: this.priceColor,
				message: loggerMessage
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/savePriceColor`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.getAllFlag()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		showInventoryFlagChange () {
			let formData = new FormData()
			formData.append('showInventoryFlag', this.showInventoryFlag)
			this.ruleForm.showInventoryFlag = this.showInventoryFlag
			const logger = this.$fxLogger.createInfo('system.mini-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setShowInventoryFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
				this.getAllFlag()
			})
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		tipsHandle (content, type, duration) {
			this.$message({
				message: content,
				type: type,
				duration: duration
			})
		},
		createLoggerParams () {
			const originData = this.fxDataVerification.getOriginData()
			const ruleForm = this.$fxUtils.deepClone(this.ruleForm)
			return {
				pre: originData,
				cur: ruleForm
			}
		},
		getAllFlag () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/findAppAll`
			}).then(res => {
				if (res.result) {
					this.registFlag = JSON.stringify(res.data.registFlag)
					this.defaultImgShowType = res.data.defaultImgShowType
					this.showInventoryFlag = res.data.showInventoryFlag
					this.allowfillpremoneyflag = res.data.allowfillpremoneyflag
					this.replaceproductpackage = res.data.replaceproductpackage
					res.data.registShopList.forEach(item => {
						item.checkFlag = true
					})
					this.registShopListFlag = res.data.registShopList.length > 0
					this.registShopList = this.$fxUtils.deepClone(res.data.registShopList)
					this.defaultcustomerdisabledflag = res.data.defaultcustomerdisabledflag
					this.isUploadFilesFlag = res.data.annexflag
					this.warningInfo = res.data.warningInfo
					this.mutexpurchase = res.data.mutexpurchase
					this.showWantArrivalDate = res.data.showWantArrivalDate
					this.showpacklist = res.data.showpacklist
					this.batchConfirm = res.data.batchConfirm
					this.warningflag = res.data.warningflag === 1
					this.packageHiddenFlag = res.data.packageHiddenFlag
					this.showOrderListDateType = res.data.showOrderListDateType
					this.showOrderListDateCount = res.data.showOrderListDateCount
					this.priceColor = res.data.priceColor
					this.weChatShippingFlag = res.data.weChatShippingFlag
					this.ruleForm = {
						registFlag: JSON.stringify(res.data.registFlag),
						defaultImgShowType: res.data.defaultImgShowType,
						allowfillpremoneyflag: res.data.allowfillpremoneyflag,
						replaceproductpackage: res.data.replaceproductpackage,
						mutexpurchase: res.data.mutexpurchase,
						showWantArrivalDate: res.data.showWantArrivalDate,
						showpacklist: res.data.showpacklist,
						showInventoryFlag: res.data.showInventoryFlag,
						defaultcustomerdisabledflag: res.data.defaultcustomerdisabledflag,
						isUploadFilesFlag: res.data.annexflag,
						warningInfo: res.data.warningInfo,
						batchConfirm: res.data.batchConfirm,
						warningflag: res.data.warningflag === 1,
						showOrderListDateCount: res.data.showOrderListDateCount
					}
					this.fxDataVerification.resetData(this.ruleForm)
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		replaceproductpackageSetting () {
			let formData = new FormData()
			formData.append('replaceproductpackage', this.replaceproductpackage)
			this.ruleForm.replaceproductpackage = this.replaceproductpackage
			const logger = this.$fxLogger.createInfo('system.mini-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setReplaceProductPackage`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.getAllFlag()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		batchConfirmSetting () {
			let formData = new FormData()
			formData.append('batchConfirm', this.batchConfirm)
			this.ruleForm.batchConfirm = this.batchConfirm
			const logger = this.$fxLogger.createInfo('system.mini-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setBatchConfirm`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.getAllFlag()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		weChatShippingFlagSetting (e) {
			if (e === 1) {
				const msg = '请确保小程序被腾讯风控再选“是”，一旦选择“是”后，无论之前是否被风控都会被腾讯风控上，请务必谨慎操作！（被风控表现为微信支付被腾讯冻结不到账，需要等腾讯后台发货后自动收货资金才会解冻，预计T+2到账）'
				this.$confirm(msg, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.weChatShippingFlagHandle()
				}).catch(() => {
					this.weChatShippingFlag = 0
				})
			} else {
				this.weChatShippingFlagHandle()
			}
		},
		weChatShippingFlagHandle () {
			const preState = this.weChatShippingFlag === 0 ? '是' : '否'
			const curState = this.weChatShippingFlag === 1 ? '是' : '否'
			let loggerMessage = `是否小程序被腾讯公众平台风控由"${preState}"改为"${curState}"`
			const params = {
				weChatShippingFlag: this.weChatShippingFlag,
				message: loggerMessage
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setWeChatShippingFlag`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.getAllFlag()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		allowfillpremoneyflagSetting () {
			let formData = new FormData()
			formData.append('allowfillpremoneyflag', this.allowfillpremoneyflag)
			this.ruleForm.allowfillpremoneyflag = this.allowfillpremoneyflag
			const logger = this.$fxLogger.createInfo('system.mini-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setAllowFillPremoneyFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.getAllFlag()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		registSetting () {
			let formData = new FormData()
			formData.append('registFlag', this.registFlag)
			this.ruleForm.registFlag = this.registFlag
			const logger = this.$fxLogger.createInfo('system.mini-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setRegistFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.getAllFlag()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		isUploadFilesFlagChange () {
			let formData = new FormData()
			formData.append('annexflag', this.isUploadFilesFlag)
			this.ruleForm.isUploadFilesFlag = this.isUploadFilesFlag
			const logger = this.$fxLogger.createInfo('system.mini-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setAnnexFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
				this.getAllFlag()
			})
		},
		saveWarningInfo () {
			let formData = new FormData()
			this.warningInfo = this.warningInfo === undefined || this.warningInfo === null || this.warningInfo.replace(/(^\s*)|(\s*$)/g, '') === '' ? '' : this.warningInfo
			formData.append('warningInfo', this.warningInfo)
			this.ruleForm.warningInfo = this.warningInfo
			const logger = this.$fxLogger.createInfo('system.mini-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/saveWarningInfo`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.getAllFlag()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		},
		setWarningFlag () {
			let formData = new FormData()
			formData.append('warningflag', this.warningflag ? 1 : 0)
			this.ruleForm.warningflag = this.warningflag
			const logger = this.$fxLogger.createInfo('system.mini-setting.update', this.createLoggerParams())
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/matchorganinfo/setWarningFlag`,
				data: formData,
				logger
			}).then(res => {
				if (res.result) {
					this.tipsHandle(res.msg, 'success', 1500)
					this.getAllFlag()
				} else {
					this.tipsHandle(res.msg, 'error', 1500)
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.el-dialog {
	border-radius: 4px
}
.el-dialog__title {
	padding-left 10px
	border-left 5px solid var(--fx-primary-color)
}
.el-dialog__body {
	padding-top: 10px
}
.dialog-title {
	text-align: left
	.el-dialog__headerbtn{
		width: 20px;
		height: 20px;
		border-radius: 50%;
		background-color: red;
		line-height: 20px;
		font-weight:blod;
		.el-icon-close{
			color:#fff
		}
	}
}
.mini-programe-body {
	display: flex;
	flex-direction: column;
	padding-left: 30px;
	.row-box{
		height: 40px;
		display: flex;
		align-items: center;
		padding-left: 200px;
	}
	.mini-programe-container {
		display flex;
		overflow-y: auto
		.el-collapse {
			.select-box{
				width:250px
			}
			.radio-wrap {
				display: flex;
				align-items: center
				.el-radio {
					margin-left: 15px;
				}
			}
			.long-span-box{
				text-align :right;
				display: inline-block;
				width :200px
				margin-bottom: 20px;
			}
			.info-textarea {
				width: 250px
			}
			.span-box{
				text-align :right;
				display: inline-block;
				width :150px
			}
			width: 100%;
			/deep/.el-collapse-item__content {
				text-align left
				padding-left 50px;
				padding-bottom 10px;
			}
			/deep/.el-collapse-item__header {
				font-size 16px
				font-weight 700px
			}
			/deep/.el-collapse-item__arrow {
				margin-left: 20px
			}
			.form-container {
				width: 100%
				.select-container {
					width: 120px
				}
			}
			.refundForm-form {
				width: 260px
				margin-top: 10px
				.select-container {
					width: 85px
				}
			}
			p {
				line-height: 28px
				color: #FF3333
				padding-left: 10px
				font-size: 14px
			}
			.order-title {
				margin-bottom 20px;
			}
			.el-radio-group {
				display flex
				flex-direction column
				.el-radio {
					margin-bottom 20px;
					margin-right auto;
					&:last-child {
						margin-bottom 0;
					}
				}
			}
		}
		.tip-icon {
			display: inline-block;
			cursor: pointer;
			margin: 0 10px 0 10px;
		}
	}
}
.color-box {
	display: flex;
	align-items: center
	.color-box-black {
		width: 12px;
		height: 12px;
		background: #333;
		border-radius: 2px;
		margin-left: 5px;
	}
	.color-box-red {
		width: 12px;
		height: 12px;
		background: #E20300;
		border-radius: 2px;
		margin-left: 5px;
	}
}
</style>
